export interface MPCObservatory {
  code: string
  longitude: number
  latitude: number
  name: string
  elevation?: number
}

interface RawMPCData {
  [code: string]: {
    obscode: string
    longitude: string
    rhocosphi: string
    rhosinphi: string
    name: string
    short_name: string
  }
}

import rawData from "./mpc-observatories.json"

// Convert rhocosphi/rhosinphi to latitude
// latitude = atan2(rhosinphi, rhocosphi) * 180 / PI
function calculateLatitude(rhocosphi: number, rhosinphi: number): number {
  return (Math.atan2(rhosinphi, rhocosphi) * 180) / Math.PI
}

// Parse and convert the raw MPC data to our format
function parseObservatories(): MPCObservatory[] {
  const data = rawData as RawMPCData
  return Object.values(data).map((obs) => ({
    code: obs.obscode,
    longitude: parseFloat(obs.longitude),
    latitude: calculateLatitude(
      parseFloat(obs.rhocosphi),
      parseFloat(obs.rhosinphi)
    ),
    name: obs.short_name || obs.name,
    elevation: 0, // MPC doesn't provide elevation, default to 0
  }))
}

export const observatories: MPCObservatory[] = parseObservatories()

// Create a lookup map for faster access
const observatoryMap = new Map<string, MPCObservatory>(
  observatories.map((obs) => [obs.code.toUpperCase(), obs])
)

export function findObservatoryByCode(
  code: string
): MPCObservatory | undefined {
  const normalized = code.trim().toUpperCase()
  return observatoryMap.get(normalized)
}

